import { motion } from "framer-motion";
import { Download } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const studies = [
  {
    key: "excelerate",
    name: "Excelerate",
    logo: "/Excelerate Logo (2).png",
    pdf: "/EXCELERATE.pdf",
  },
  {
    key: "slu",
    name: "Saint Louis University",
    logo: "/Slu Logo (3).png",
    pdf: "/SAINT LOUIS UNIVERSITY.pdf",
  },
  {
    key: "tiger-stripes",
    name: "Tiger STRIPES",
    logo: "/Rit Logo.png",
    pdf: "/ROCHESTER INSTITUTE OF TECHNOLOGY.pdf",
  },
];

export const CaseStudies = () => {
  return (
    <section id="work" className="bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-3xl mx-auto text-center">
          <motion.p variants={fadeUp} className="eyebrow text-[#FF6A3D] mb-6">
            Case Studies
          </motion.p>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
            Read More About Raj&rsquo;s Work That is Shaping Global Education Brands
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {studies.map((s) => (
            <motion.div
              variants={fadeUp}
              key={s.key}
              data-testid={`case-card-${s.key}`}
className="group bg-white rounded-[28px] border border-[#1A2238]/8 shadow-[0_18px_60px_rgba(26,34,56,0.08)] p-10 flex flex-col items-center justify-between min-h-[250px] transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(26,34,56,0.12)]"            >
              <div className="h-40 flex items-center justify-center mb-8">
  <img
    src={s.logo}
    alt={s.name}
className="max-h-28 max-w-[260px] w-auto object-contain transition-transform duration-300 group-hover:scale-105"  />
</div>


              <a
  href={s.pdf}
  download
  target="_blank"
  rel="noopener noreferrer"
  data-testid={`case-download-${s.key}`}
  className="group/btn mt-7 inline-flex items-center gap-2.5 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-sm py-3 px-6 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_28px_rgba(255,106,61,0.4)]"
>
                Download Now
                <Download size={16} className="transition-transform duration-300 group-hover/btn:translate-y-0.5" />
              </a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
